import React, { useEffect, useState, Fragment, useContext, useMemo, useRef } from 'react';
import Layout from 'components/sales/layout/layout';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import GateCard from 'components/sales/cardSection/gateCard/gateCard';
import { MrfStatus } from 'components/installation/mrfStatus/mrfStatus';
import ModalPop from 'components/sales/modal/modal';
import FormSectionNew from 'components/sales/formSection/formSectionNew';
import { Button } from 'react-bootstrap';
import Checkbox from 'components/sales/Input/checkbox/checkbox';
import DocumentView from 'components/sales/downloadDocView/documentView';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import Regex from 'services/utils/regex/Regex';
import { ConsolidateReport } from 'components/installation/consolidateReport/consolidateReport';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import useLatLng from 'hooks/uselatlng/uselatlng';
import { Link } from "react-router-dom";
import './siteInspection.css'
import HandoverInvoicePreview from './handoverInvoicePreview';
import DistanceCalculator from "../../DistanceCalculator/Calculator";
import { toast } from "react-toastify";
import { BaseUrl } from "../../../contexts/baseUrl/baseUrl";
import FileUpload from "components/sales/fileUpload/fileUpload";
import FormSection from 'components/sales/formSection/formSection';
import DatePicker from 'components/sales/datePicker/datePicker';
import { SOLUTION_TYPE } from 'constants/solutionType';
import { endOfDay, startOfDay, subDays } from 'date-fns';
import {
  canShowGenerateReport,
  getReportPendingMessage,
  hasValidReportUrl,
  isReportComplete,
  shouldShowReportAttachment,
  shouldShowReportPending,
} from 'services/utils/reportUrl/reportUrl';

const readReconContractId = (site) => {
  if (!site || typeof site !== 'object') return null;
  const value =
    site.recon_contract_id ??
    site.commercial?.recon_contract_id ??
    site.lead_comm?.recon_contract_id ??
    site.lead?.recon_contract_id ??
    site.contract?.recon_contract_id ??
    site.site_data?.recon_contract_id;
  if (value === null || value === undefined || value === '') return null;
  return value;
};

const SiteInspection = ({
  getSiteInspect,
  siteData,
  match,
  history,
  documentUploadUrl,
  postReportDetails,
  generateReport,
  getLocationApprovalPending,
  location,
  locationApproval,
  getPocBySiteId,
  pocListBySiteId,
  postSendReportMail,
  getCheckLocation,
  locationCheck,
  userProfile,
  getSiteData,
  calculateDistance,
  engDistanceData,
  siteDetails,
  getDistanceData,
  distanceDetails,
  documentUploadUrlPublic,
  documentUrlDataPublic,
  updateSiteConsumesByOps,
  previewHandoverValetContract,
}) => {
  const islatlng = useLatLng();
  const [modalFlag, setModalFlag] = useState(null);
  const [isModal, setIsModal] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [generateFlag, setGenerateFlag] = useState(false);
  const [reportSuccessMessage, setReportSuccessMessage] = useState(
    localization.reportSuccess
  );
  const [reportGenerationSubmitted, setReportGenerationSubmitted] = useState(false);
  const [mrfReportModal, setMrfReportModal] = useState(false);
  const [generateReportFlag, setGenerateReportFlag] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [flag, setFlag] = useState(false);
  const [poclist, setPocList] = useState([]);
  const [modal, setModal] = useState(false);
  const [showOtherEmail, setShowOtherEmail] = useState(false);
  const [mailList, setMailList] = useState([]);
  const [otherEmail, setOtherEmail] = useState();
  const [rentalInvoice, setRentalInvoice] = useState('');
  const [rentalCheck, setRentalCheck] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [role, setRole] = useState('')
  const { baseUrl } = useContext(BaseUrl);
  const [opened, setIsOpened] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [passCode, setPasscode] = useState(null);
  const [docFileUrl, setDocFileUrl] = useState(null);
  const [containerData, setContainerData] = useState(['site-inspection', 'civil-checklist', 'hardware-installation', 'handover-testing']);
  const [masterConsumables, setMasterConsumables] = useState(null);
  const [addItem, setAddItem] = useState(1);
  const [isSuccessModel, setIsSuccessModel] = useState(false);
  const [consumablesInput, setComsumablesInput] = useState({
    consumables: "no",
    consumablesData: [{
      id: "",
      uom: "",
      sales_qty: "",
      ops_qty: "",
      base_unit_price: "",
      sale_unit_price: "",
      remarks: "",
      is_new: false
    }]
  });
  const [installationAmount, setInstallationAmount] = useState(0);
  const [cartageAmount, setCartageAmount] = useState(0);
  const [handoverDate, setHandoverDate] = useState(null);
  const [manualInvoices, setManualInvoices] = useState([
    { invoice_number: '', billing_start_date: '', billing_end_date: '' },
  ]);
  const handoverGenerateRef = useRef(null);
  const [handoverPreview, setHandoverPreview] = useState(null);
  const [handoverPreviewConfirmed, setHandoverPreviewConfirmed] = useState(false);
  const [handoverPreviewSignature, setHandoverPreviewSignature] = useState('');
  const handoverDateBounds = useMemo(() => {
    const today = new Date();
    return {
      minDate: startOfDay(subDays(today, 45)),
      maxDate: endOfDay(today),
    };
  }, []);
  const solutionType = Number(
    siteData?.solution_type ?? siteData?.site_data?.solution_type
  );
  const isServiceHandover =
    match.params.gate === 'handover-testing' &&
    solutionType === SOLUTION_TYPE.SERVICE;

  const isReportPending = shouldShowReportPending(
    siteData,
    match.params.stageId,
    reportGenerationSubmitted
  );
  const reportPendingMessage = getReportPendingMessage();
  const showGenerateReport = canShowGenerateReport(
    siteData,
    match.params.stageId,
    reportGenerationSubmitted
  );

  useEffect(() => {
    if (isReportComplete(siteData, match.params.stageId)) {
      setReportGenerationSubmitted(false);
    }
  }, [siteData?.report_url, siteData?.report_status, match.params.stageId]);

  //console.log(docFileUrl);
  useEffect(() => {
    let roles = JSON.parse(localStorage.getItem('roles'))
    setRole(roles[0]?.id)
    setIsOpen(!isOpen);
  }, [])

  useEffect(() => {
    (async () => {
      await getDistanceData(match.params.id, match.params.gate)
    })()
  }, [match.params.gate])

  useEffect(() => {
    setIsOpen(true)
    if (distanceDetails && Object.keys(distanceDetails).length > 0) {
      if (!distanceDetails['total_hours']) {
        setIsOpen(false);
      }
    }
  }, [distanceDetails])

  useEffect(() => {
    (() => {
      if (
        poclist &&
        poclist.length > 0
      ) {
        setShowOtherEmail(true);
      } else {
        setShowOtherEmail(false);
      }
      // if (
      //   poclist &&
      //   Object.values(poclist.length) > 0 &&
      //   Object.values(poclist).some((obj) => obj.id === 'Others')
      // ) {
      //   setShowOtherEmail(true);
      // } else {
      //   setShowOtherEmail(false);
      // }
    })();
  }, [poclist]);

  useEffect(() => {
    if (
      getSiteInspect !== null &&
      match.params.id &&
      getLocationApprovalPending !== null
    )
      (async () => {
        setIsLoading(true);
        await getSiteInspect(match.params.id, match.params.stageId);
        if (match.params.gate === 'site-inspection') {
          await getLocationApprovalPending(
            match.params.id,
            islatlng?.lat,
            islatlng?.lng
          );
        } else {
          await getCheckLocation(match.params.id, islatlng?.lat, islatlng?.lng);
        }
        await getPocBySiteId(match.params.id);
        setIsLoading(false);
      })();
  }, [getSiteInspect, getLocationApprovalPending, match.params.id, islatlng]);

  // load consumables
  useEffect(() => {
    if (siteData !== undefined && siteData?.consumales_items?.dropdown && siteData?.site_data?.filled_consumables && siteData?.site_data?.installation_amount && siteData?.site_data?.cartage_amount) {
      setMasterConsumables(siteData?.consumales_items?.dropdown);
      setComsumablesInput({
        ...consumablesInput,
        consumables: "Yes",
        consumablesData: siteData?.site_data?.filled_consumables
        .map(item => ({ ...item, is_new: false })),
      });
      setInstallationAmount(siteData?.site_data?.installation_amount);
      setCartageAmount(siteData?.site_data?.cartage_amount);
    }
  }, [siteData]);

  const handleModalHide = () => setModalFlag(null);
  const modalHide = () => setIsModal(null);
  const mrfReportModalHide = () => setMrfReportModal(false);
  const openHideModal = () => setOpenModal(false);
  const emailModalHide = () => setModal(false);
  const checkInventory = (val) => {
    setFlag(val);
    siteData &&
      siteData.gates &&
      siteData.gates.length > 0 &&
      siteData.gates.map((obj) => {
        obj.checklist_data.map((el) => {
          if (el.checklist_id === 8 && (el.completed === 1 || obj.is_material_update === 1)) {
            setModalFlag(false);
          }
          else if (el.checklist_id === 8 && (el.completed === null)) {
            setModalFlag(true);
          }

        });
      });
  };

  useEffect(() => {
    if (modalFlag === false && modalFlag !== null) {
      history.push({
        pathname: `/dashboard/material-requisition/${match.params.id}/stage/${match.params.stageId}`,
        state: { view: flag, status: location.state && location.state.status },
      });
    }
  }, [modalFlag]);

  const onClickViewMrf = (val) => {
    checkInventory(val);
  };

  const areSiteChecklistsComplete = (checklists = []) =>
    Array.isArray(checklists) &&
    checklists.length > 0 &&
    checklists.every((item) => item?.completed === 1);

  const areGateChecklistsComplete = (gates = [], { allowMaterialUpdate = false } = {}) =>
    Array.isArray(gates) &&
    gates.length > 0 &&
    gates.every((gate) => {
      const checklists = gate?.checklist_data || [];
      if (checklists.length === 0) return false;
      return checklists.every(
        (item) =>
          item?.completed === 1 ||
          (allowMaterialUpdate && gate?.is_material_update === 1)
      );
    });

  const hasHandoverDate = () => {
    if (!isServiceHandover) return true;
    if (handoverDate && handoverDate !== 'Invalid date') return true;
    setIsDisabled(false);
    toast.error('Please select Handover Date');
    return false;
  };

  const updateManualInvoice = (index, key, value) => {
    setManualInvoices((rows) =>
      rows.map((row, rowIndex) =>
        rowIndex === index ? { ...row, [key]: value || '' } : row
      )
    );
  };

  const addManualInvoice = () => {
    setManualInvoices((rows) => [
      ...rows,
      { invoice_number: '', billing_start_date: '', billing_end_date: '' },
    ]);
  };

  const removeManualInvoice = (index) => {
    setManualInvoices((rows) =>
      rows.length === 1
        ? rows
        : rows.filter((_, rowIndex) => rowIndex !== index)
    );
  };

  const toInvoiceDate = (value) => {
    if (!value || value === 'Invalid date') return null;
    const parts = String(value).split('-');
    if (parts.length !== 3) return null;
    const [day, month, year] = parts.map(Number);
    const date = new Date(year, month - 1, day);
    if (
      Number.isNaN(date.getTime()) ||
      date.getDate() !== day ||
      date.getMonth() !== month - 1
    ) {
      return null;
    }
    return date;
  };

  const completedManualInvoices = () => {
    if (!isServiceHandover) return [];
    return manualInvoices.reduce((rows, row) => {
      const invoiceNumber = (row.invoice_number || '').trim();
      const startDate = row.billing_start_date;
      const endDate = row.billing_end_date;
      const hasStart = startDate && startDate !== 'Invalid date';
      const hasEnd = endDate && endDate !== 'Invalid date';
      if (!invoiceNumber && !hasStart && !hasEnd) return rows;
      rows.push({
        invoice_number: invoiceNumber,
        billing_start_date: hasStart ? startDate : '',
        billing_end_date: hasEnd ? endDate : '',
      });
      return rows;
    }, []);
  };

  const manualInvoicesAreValid = () => {
    if (!isServiceHandover) return true;
    const rows = completedManualInvoices();
    const incomplete = rows.find(
      (row) =>
        !row.invoice_number ||
        !row.billing_start_date ||
        !row.billing_end_date
    );
    if (incomplete) {
      setIsDisabled(false);
      toast.error(
        'Complete invoice number, billing start date, and billing end date, or leave the row empty.'
      );
      return false;
    }
    const outOfOrder = rows.find((row) => {
      const start = toInvoiceDate(row.billing_start_date);
      const end = toInvoiceDate(row.billing_end_date);
      return start && end && end < start;
    });
    if (outOfOrder) {
      setIsDisabled(false);
      toast.error('Billing end date cannot be before billing start date.');
      return false;
    }
    return true;
  };

  const handoverPreviewSignatureNow = () =>
    JSON.stringify({
      handoverDate:
        handoverDate && handoverDate !== 'Invalid date' ? handoverDate : '',
      invoices: completedManualInvoices(),
    });

  useEffect(() => {
    if (!handoverPreviewSignature) return;
    if (handoverPreviewSignatureNow() !== handoverPreviewSignature) {
      setHandoverPreview(null);
      setHandoverPreviewConfirmed(false);
      setHandoverPreviewSignature('');
    }
  }, [handoverDate, manualInvoices, handoverPreviewSignature]);

  const getHandoverContractId = async () => {
    const fetchedSite = await getSiteData(match.params.id);
    return readReconContractId(fetchedSite) ?? readReconContractId(siteDetails);
  };

  const handleHandoverPreview = async () => {
    if (!isServiceHandover) return;
    if (!hasHandoverDate() || !manualInvoicesAreValid()) return;
    setIsLoading(true);
    const contractId = await getHandoverContractId();
    if (contractId === null || contractId === undefined || contractId === '') {
      setIsLoading(false);
      toast.error('Recon contract id is not available for this site.');
      return;
    }
    setHandoverPreview(null);
    setHandoverPreviewConfirmed(false);
    const res = await previewHandoverValetContract({
      contract_id: contractId,
      handover_date: handoverDate,
      invoice_data: completedManualInvoices(),
    });
    setIsLoading(false);
    if (!res?.success) return;
    setHandoverPreview(res.data);
    setHandoverPreviewSignature(handoverPreviewSignatureNow());
  };

  const checklisting = () => {
    setIsDisabled(true);

    if (isServiceHandover && !handoverPreviewConfirmed) {
      setIsDisabled(false);
      toast.error('Preview and confirm the invoice details before generating the handover report.');
      return;
    }

    const isCivilOrHardwareOrHandover =
      match.params.gate === 'civil-checklist' ||
      match.params.gate === 'hardware-installation' ||
      match.params.gate === 'handover-testing';

    if (isCivilOrHardwareOrHandover) {
      // Channel-partner sites historically skip checklist gate before report.
      if (siteData?.channel_partner_id) {
        if (!hasHandoverDate()) return;
        if (!manualInvoicesAreValid()) return;
        setIsDisabled(false);
        setIsModal(false);
        return;
      }

      if (match.params.gate === 'handover-testing') {
        const complete = areSiteChecklistsComplete(siteData?.checklist_data);
        if (complete && !hasHandoverDate()) return;
        if (complete && !manualInvoicesAreValid()) return;
        setIsDisabled(false);
        setIsModal(!complete);
        return;
      }

      // civil-checklist / hardware-installation (stage 4): ALL gates must have
      // ALL checklists completed. Previous logic used setState inside .map so the
      // last checklist item won — one completed row unlocked generate report.
      const complete = areGateChecklistsComplete(siteData?.gates);
      setIsDisabled(false);
      setIsModal(!complete);
      return;
    }

    if (parseFloat(match.params.stageId) !== 13) {
      if (siteData?.channel_partner_id) {
        setIsDisabled(false);
        setIsModal(false);
        return;
      }

      if (
        siteData &&
        Object.prototype.hasOwnProperty.call(siteData, 'mrf') &&
        siteData.mrf &&
        Object.keys(siteData.mrf).length === 0
      ) {
        setIsDisabled(false);
        setMrfReportModal(true);
        return;
      }

      const complete = areGateChecklistsComplete(siteData?.gates, {
        allowMaterialUpdate: true,
      });
      setIsDisabled(false);
      setIsModal(!complete);
      return;
    }

    setIsDisabled(true);
    setIsModal(false);
  };

  useEffect(() => {
    (async () => {
      if (isModal === false) {
        const data = {
          site_id: match.params.id,
          stage_id: match.params.stageId,
          passCode: passCode,
          fileAttached: docFileUrl,
          ...(isServiceHandover && handoverDate ? { handover_date: handoverDate } : {}),
          ...(isServiceHandover
            ? { invoice_data: completedManualInvoices() }
            : {}),
        };
        setIsLoading(true);
        const res = await generateReport(data);
        setIsLoading(false);
        if (res?.success) {
          setReportSuccessMessage(res.message || localization.reportSuccess);
          setGenerateFlag(true);
          setReportGenerationSubmitted(true);
          getSiteInspect(match.params.id, match.params.stageId);
        }
      }
    })();
  }, [isModal]);

  useEffect(() => {
    if (
      Object.keys(siteData?.report_data !== undefined && siteData?.report_data)
        .length > 0
    ) {
      setGenerateReportFlag(true);
    } else if (
      Object.keys(siteData?.report_data !== undefined && siteData?.report_data)
        .length === 0
    ) {
      setGenerateReportFlag(false);
    }
  }, [siteData]);

  const hideReport = () => {
    setGenerateFlag(false);
    getSiteInspect(match.params.id, match.params.stageId);
  };

  const sendMail = (val) => {
    if (val) {
      setOpenModal(true);
    }
  };
  useEffect(() => {
    const list =
      poclist && poclist.length > 0 && poclist.map((element) => element['id']);
    setMailList(list);
  }, [poclist]);

  const sendMailPoc = async () => {
    const findIndex =
      mailList &&
      mailList.length > 0 &&
      mailList.findIndex((el) => el === 'Others');
    if (findIndex !== -1) {
      mailList.splice(findIndex, 1);
      mailList.push(otherEmail);
      setMailList([...mailList]);
    }
    const data = {
      stage_id: match.params.stageId,
      site_id: match.params.id,
      pocs: mailList,
    };
    if (data.pocs.length > 0) {
      setIsLoading(true);
      openHideModal();
      const res = await postSendReportMail(data);
      setIsLoading(false);
      if (res === true) {
        setModal(true);
      }
    }
  };

  useEffect(() => {
    if (engDistanceData !== null && Object.keys(engDistanceData).length > 0) {
      toast.success('Distance is successfully fetched');
      setIsOpen(false);
      Object.keys(engDistanceData).forEach(key => {
        delete engDistanceData[key];
      })
    } else if (engDistanceData === null) {
      toast.success('Distance is not fetched');
      setIsOpen(true);
    }
  }, [engDistanceData])

  const handleAddClick = () => {
    setComsumablesInput(prevState => ({
      ...prevState,
      consumablesData: [
        ...prevState.consumablesData,
        {
          id: "",
          uom: "",
          sales_qty: "",
          ops_qty: "",
          base_unit_price: "",
          sale_unit_price: "",
          remarks: "",
          is_new: true
        },
      ],
    }));
  };

  const handleRemoveClick = (index) => {
    setComsumablesInput(prevState => ({
      ...prevState,
      consumablesData: prevState.consumablesData.filter((_, i) => i !== index)
    }));
  };

  const handleInput2Value = (val, key, index) => {
    if (val !== undefined && key) {
      setComsumablesInput(prevState => ({
        ...prevState,
        consumablesData: prevState.consumablesData.map((item, i) => {
          if (i !== index) return item;
  
          if (key === 'id') {

            return {
              ...item,
              id: val,
              uom: siteData?.consumales_items?.all_consumbales?.[val]?.uom || null,
              base_unit_price: siteData?.consumales_items?.all_consumbales?.[val]?.base_price || null,
            };
          } else if (key === 'sales_qty') {
            return {
              ...item,
              sales_qty: val,
              ops_qty: val
            };
          } else if (key === 'sale_unit_price') {
            return {
              ...item,
              sale_unit_price: val
            };
          } else if (key === 'remarks') {
            return {
              ...item,
              remarks: val
            };
          } else if (siteData?.consumales_items?.all_consumbales?.[val]?.[key] !== undefined) {
            return {
              ...item,
              [key]: siteData?.consumales_items?.all_consumbales?.[val]?.[key]
            };
          } else {
            return {
              ...item,
              [key]: val
            };
          }
        })
      }));
    }
  };  

  const handleConsumeData = async () => {
    if(consumablesInput?.consumables && consumablesInput?.consumables === 'Yes') {
      // console.log('dd ' + JSON.stringify(consumablesInput?.consumablesData));
      var allChecks = false;
      var consumbalesAmt = 0;
      consumablesInput?.consumablesData.forEach(element => {
        if(element.ops_qty == '' || element.ops_qty == 0) {
          toast.error('Ops Quantity is required');
          allChecks = true;
          return false;
        }
        // if(element.base_unit_price == '') {
        //   toast.error('Unit price is required');
        //   allChecks = true;
        //   return false;
        // }
        if(element.sale_unit_price == '') {
          toast.error('Sale Unit price is required');
          allChecks = true;
          return false;
        }
        consumbalesAmt = consumbalesAmt + (parseFloat(element.sale_unit_price) * parseFloat(element.sales_qty));
      });
      if(parseFloat(installationAmount) > 0){
        if(consumbalesAmt > parseFloat(installationAmount)){
          toast.error('Consumables amount can not be greater then installation amount.');
          return false;
        }
      }
      if(allChecks) {
        return false;
      }
    }
    setIsLoading(true);
    consumablesInput['comm_id'] = siteData?.site_data?.comm_id;
    consumablesInput['installation_amount'] = installationAmount;
    // consumablesInput['cartage_amount'] = cartageAmount;
    const res = await updateSiteConsumesByOps(consumablesInput);
    if(res == true) {
        setIsLoading(false);
        setIsSuccessModel(true);
    } else {
      setIsLoading(false);
      toast.error('Error in updating contract details');
    }
  }
  
  const handleRejectModalHide = () => {
    setIsSuccessModel(false);
    getSiteInspect(match.params.id, match.params.stageId);
  }

  const successIconBox = (text, func) => {
    return (
      <div className="text-center">
        <div className="success">
          <img src={Images?.tick} alt="" />
        </div>
        <h5>{text}</h5>
        <button onClick={handleRejectModalHide} className='btn btn-primary btn-sm text-center'>Close</button>
      </div>
    );
  };

  return (


    <Layout
      title={
        match.params.gate &&
        match.params.gate
          .replace('-', ' ')
          .split(' ')
          .map(function (word) {
            return word.replace(word[0], word[0].toUpperCase());
          })
          .join(' ')
      }
      status={location.state && location.state.status}
      isGoback
      isLoading={isLoading}
      linkFlag={true}
      linkUrl={`/dashboard/site-stage/${match.params.id}`}
    >
      {role === 9 && isOpen && opened ?
        <div className="popup-box">
          <div className="box">
            {siteDetails?.lead_id !== undefined &&
              <Link
                to={`${baseUrl}/site-stage/${match.params.id}/${siteDetails?.lead_id}`}
                className="btn btn-primary mb-4"
                style={{
                  'cursor': 'pointer',
                  'border': '0px',
                  'box-shadow': 'none !important',
                  'position': 'relative',
                  'top': '-17px',
                  'float': 'right'
                }}
              >
                x
              </Link>
            }
            <DistanceCalculator
              siteData={siteDetails}
              getSiteData={getSiteData}
              calculateDistance={calculateDistance}
              siteId={match.params.id}
              moduleType={match.params.gate}
              to={`${baseUrl}/site-stage/${match.params.id}/${siteDetails?.lead_id}`}
            />
          </div>
        </div> :
        <>
          {siteData && siteData.site_data &&
            <>
              <div className="col-md-12 col-xs-12">
                <h4>{siteData.site_data.client_name} ({siteData.site_data.site_no})</h4>
              </div>
              <div className="col-md-3"></div>
            </>
          }
          {/* <div className="civil-parent" >
      <div className="panel-parent">
        <div className="panel-card-listing panel-card-child"> */}
          <div style={{ display: "block" }}>
            <div className="col-md-12">
              {match.params.gate === 'handover-testing' &&
                siteData &&
                siteData.checklist_data && (
                  <div className="handover-checklist-wrap">
                    <GateCard
                      data={siteData}
                      history={history}
                      match={match}
                      islocationValid={
                        location.state && location.state.islocationValid
                      }
                      locationApproval={locationCheck}
                    />
                  </div>
                )}
              {match.params.gate !== 'handover-testing' && (
              <div className="card">
                {match.params.stageId == 13 &&
                  <>
                    <div className="card-header n-card">{localization.capexDetails}</div>
                    <div className='card-body'>
                      <>
                        <div className='row'>
                          <div className='col-md-12' style={{ marginBottom: '10px' }}>
                            <span><b>Contract Amount :</b> &nbsp;₹&nbsp;
                              {(parseFloat(siteData?.site_data?.total_mg_amount)+parseFloat(siteData?.site_data?.installation_amount)+parseFloat(siteData?.site_data?.cartage_amount)+parseFloat(siteData?.tags_amount)).toFixed(2)}
                            </span>
                          </div>
                        </div>

                        <div className='row' style={{ marginBottom: '10px' }}>
                          <div className='col-md-3'>
                            <span><b>Hardware Amount :</b> &nbsp;₹&nbsp;
                              {parseFloat(siteData?.site_data?.total_mg_amount).toFixed(2)}
                            </span>
                          </div>
                          <div className='col-md-3'>
                            <span><b>Installation Amount :</b> &nbsp;₹&nbsp;
                              { parseFloat(siteData?.site_data?.installation_amount).toFixed(2)}
                            </span>
                          </div>
                          <div className='col-md-3'>
                            <span><b>Cartage Amount :</b> &nbsp;₹&nbsp;
                              { parseFloat(siteData?.site_data?.cartage_amount).toFixed(2)}
                            </span>
                          </div>
                          <div className='col-md-3'>
                            <span><b>Tags Amount :</b> &nbsp;₹&nbsp;
                              { parseFloat(siteData?.tags_amount).toFixed(2)}
                            </span>
                          </div>
                        </div>
                      </>
                    </div>

                    <div className='card-body'>
                      <div className="row">
                        {/* <div className="col-md-3 col-sm-12">
                          <ConstantInput
                            label={localization.installationCharge}
                            type="number"
                            className="indianrupee"
                            isPrefix
                            prefixText={'₹'}
                            required
                            isStarRequired={true}
                            handleChange={(val) => {
                              setInstallationAmount(val);
                            }}
                            value={installationAmount}
                          />
                        </div> */}
                        {/* <div className="col-md-3 col-sm-12">
                          <ConstantInput
                            label={localization.cartage_amount}
                            type="number"
                            className="indianrupee"
                            isPrefix
                            prefixText={'₹'}
                            required
                            isStarRequired={true}
                            handleChange={(val) => {
                              setCartageAmount(val);
                            }}
                            value={cartageAmount}
                          />
                        </div> */}
                      </div>
                      
                    </div>


                    <div className="card-header n-card">{localization.consumables}</div>
                    <div className='card-body'>
                      {addItem === 1 ? (
                        <>
                          {masterConsumables && consumablesInput?.consumablesData?.length > 0 && consumablesInput?.consumablesData.map((x, i) => {
                            return (
                              <div key={'k_' + i}>
                                <div className="row">
                                  <div className="col-md-3 col-sm-12">
                                    <DropDownInput
                                      label={localization.consumables}
                                      data={masterConsumables}
                                      required
                                      errorMsg={localization.requiredScope}
                                      getIdValue={(val) => {
                                        handleInput2Value(val.id, "id", i);
                                      }}
                                      value={siteData?.consumales_items?.all_consumbales?.[x?.id]?.['service_name'] ?? ''}
                                      isStarRequired={true}
                                    />
                                  </div>
                                  <div className="col-md-3 col-sm-12">
                                    <ConstantInput
                                      label={localization.uom}
                                      type="text"
                                      required
                                      isStarRequired={true}
                                      value={x?.uom}
                                      disabled={true}
                                    />
                                  </div>
                                  <div className="col-md-3 col-sm-12">
                                    <ConstantInput
                                      label={localization.requiredQty}
                                      className=""
                                      type="number"
                                      required
                                      isStarRequired={true}
                                      handleChange={(val) => {
                                        handleInput2Value(val, "sales_qty", i);
                                      }}
                                      value={x?.sales_qty}
                                      disabled={(x?.scope && x?.scope == 1) ? true : false}
                                    />
                                  </div>
                                  <div className="col-md-3 col-sm-12">
                                    <ConstantInput
                                      label={`Base Unit Price`}
                                      className="indianrupee"
                                      isPrefix
                                      prefixText={'₹'}
                                      type="number"
                                      handleChange={(val) => {
                                        handleInput2Value(val, "base_unit_price", i);
                                      }}
                                      value={x?.base_unit_price}
                                      disabled={true}
                                    />
                                  </div>
                                  <div className="col-md-3 col-sm-12">
                                    <ConstantInput
                                      label={`Sale Unit Price`}
                                      className="indianrupee"
                                      isPrefix
                                      prefixText={'₹'}
                                      type="number"
                                      required
                                      isStarRequired={true}
                                      handleChange={(val) => {
                                        handleInput2Value(val, "sale_unit_price", i);
                                      }}
                                      value={x?.sale_unit_price}
                                      disabled={x?.is_new === true ? false : true}
                                    />
                                  </div>
                                  <div className="col-md-3 col-sm-12">
                                    <ConstantInput
                                      label={`Total Price`}
                                      className="indianrupee"
                                      isPrefix
                                      prefixText={'₹'}
                                      type="number"
                                      required
                                      isStarRequired={true}
                                      value={parseFloat(x?.sale_unit_price * x?.sales_qty)}
                                      disabled={true}
                                    />
                                  </div>
                                  <div className="col-md-3 col-sm-12">
                                    <ConstantInput
                                      label={`Specification`}
                                      className=""
                                      type="text"
                                      handleChange={(val) => {
                                        handleInput2Value(val, "remarks", i);
                                      }}
                                      value={x?.remarks}
                                    />
                                  </div>
                                  <div className="col-md-3 col-sm-12 d-flex">
                                    {consumablesInput?.consumablesData.length !== 1 && (
                                      <div className="col-md-2 col-sm-5">
                                        <button
                                          onClick={() => handleRemoveClick(i)}
                                          className="mr10 btn btn-sm btn-danger"
                                        >
                                          Remove
                                        </button>
                                      </div>
                                    )}
                                    {consumablesInput?.consumablesData.length - 1 === i && (
                                      <div className="col-md-2 col-sm-5">
                                        <button
                                          className="btn btn-sm btn-primary"
                                          onClick={handleAddClick}
                                        >
                                          Add
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </>
                      ) : addItem === 2 ? (
                        {}
                      ) : null}
                    </div>
                    <div className="form-group col-10">
                      <button
                      type="button"
                      className="btn btn-primary btn-sm"
                      onClick={() => handleConsumeData()}
                      >
                      {'Update Contract'} <img src="" alt="" />
                      </button>
                    </div>
                  </>
                }


                {siteData &&
                  siteData.gates &&
                  siteData.gates.length > 0 &&
                  siteData.gates.map((obj, index) => {
                    return (
                      <div className="card-body" key={index}>
                        <GateCard
                          data={obj}
                          history={history}
                          match={match}
                          islocationValid={
                            location.state && location.state.islocationValid
                          }
                          locationApproval={
                            match.params.gate === 'site-inspection'
                              ? locationApproval
                              : locationCheck
                          }
                        />
                      </div>
                    );
                  })}
              </div>
              )}
            </div>
            {match.params.stageId == 7 &&
              <div className='col-md-12'>
                <div className='card'>
                  <div className="card-header">{localization.fillFirstInteraction}</div>
                  <div className='card-body'>
                    {match.params.stageId == 7 && siteData.fir_filled == 0 ? (
                      <>
                        {/* <a class="btn btn-primary">Fill First Interacion Form</a> */}
                        {siteData.site_data?.lead_type === 2 ? (
                          <Link
                            to={`${baseUrl}/interaction-fir-form/${match.params.id}`}
                            className="btn btn-primary mb-4"
                          >
                            Fill First Interaction Form
                          </Link>
                        ) :
                          <Link
                            to={`${baseUrl}/corporate-interaction-form/${match.params.id}`}
                            className="btn btn-primary mb-4"
                          >
                            Fill First Interaction Form
                          </Link>
                        }
                      </>
                    ) :
                      <a class="btn btn-primary" style={{ 'pointer-events': 'none' }}>FIR Filled</a>
                    }
                  </div>
                </div>
              </div>
            }

            <div className="col-md-12">
              {!(isReportPending && !siteData.stage_attachment) && (
              <FormSectionNew title={localization.addAttachment}>
                {!hasValidReportUrl(siteData?.report_url) &&
                  containerData.includes(match.params.gate) &&
                  showGenerateReport ? (
                    <>
                      <FileUpload
                        id={"addAttachment"}
                        accept=".pdf,.png,.jpg,.jpeg,.doc,.mp4,.webm,.mkv"
                        documentUploadUrl={documentUploadUrlPublic}
                        documentUrlData={documentUrlDataPublic}
                        onChange={(val) =>
                          setDocFileUrl(val)
                        }
                      //multiple={true}
                      >
                        <span className="btn btn-transparent">
                          {localization.document}
                        </span>

                      </FileUpload>
                    </>
                ) : siteData.stage_attachment != null &&
                  siteData.stage_attachment != '' ? (
                    <div className="form-group">
                      <DocumentView attachment={siteData && siteData.stage_attachment} />
                    </div>
                  ) : !hasValidReportUrl(siteData?.report_url) ? (
                  'No File Attached'
                ) : null}
              </FormSectionNew>
              )}
              {isServiceHandover && showGenerateReport && (
                <div className="handover-manual-invoice">
                  <FormSectionNew title="Manual Invoice">
                    {manualInvoices.map((row, index) => (
                      <div className="row handover-manual-invoice__row" key={index}>
                        <div className="col-md-3 col-sm-12">
                          <ConstantInput
                            label="Invoice Number"
                            type="text"
                            value={row.invoice_number}
                            handleChange={(val) =>
                              updateManualInvoice(index, 'invoice_number', val)
                            }
                          />
                        </div>
                        <div className="col-md-3 col-sm-12">
                          <DatePicker
                            label="Billing Start Date"
                            required={false}
                            value={row.billing_start_date || null}
                            handleChange={(val) =>
                              updateManualInvoice(
                                index,
                                'billing_start_date',
                                val && val !== 'Invalid date' ? val : ''
                              )
                            }
                          />
                        </div>
                        <div className="col-md-3 col-sm-12">
                          <DatePicker
                            label="Billing End Date"
                            required={false}
                            value={row.billing_end_date || null}
                            handleChange={(val) =>
                              updateManualInvoice(
                                index,
                                'billing_end_date',
                                val && val !== 'Invalid date' ? val : ''
                              )
                            }
                          />
                        </div>
                        <div className="col-md-2 col-sm-12 handover-manual-invoice__actions">
                          {manualInvoices.length > 1 && (
                            <Button
                              type="button"
                              className="btn btn-sm btn-danger"
                              onClick={() => removeManualInvoice(index)}
                            >
                              Remove
                            </Button>
                          )}
                        </div>
                      </div>
                    ))}
                    <Button
                      type="button"
                      className="btn btn-sm btn-primary handover-manual-invoice__add"
                      onClick={addManualInvoice}
                    >
                      Add More
                    </Button>
                  </FormSectionNew>
                </div>
              )}
              {match.params.gate === 'site-inspection' && (
                <Fragment>
                  {siteData && siteData?.channel_partner_id == null
                    ?
                    <MrfStatus
                      handleValue={onClickViewMrf}
                      match={match}
                      data={siteData && siteData.mrf}
                    />
                    :
                    null
                  }

                  <ConsolidateReport
                    match={match}
                    reportUrl={siteData && siteData.report_url}
                    reportStatus={siteData && siteData.report_status}
                    mrf={siteData && siteData.mrf}
                    documentUploadUrl={documentUploadUrl}
                    postReportDetails={postReportDetails}
                    reportFlag={generateReportFlag}
                    reportPendingMessage={reportPendingMessage}
                    isReportPending={isReportPending}
                    pocListBySiteId={pocListBySiteId}
                    postSendReportMail={postSendReportMail}
                    refreshPage={(val) => {
                      if (val) {
                        getSiteInspect(match.params.id, match.params.stageId);
                      }
                    }}
                    generateReport={(val) => {
                      if (val) {
                        checklisting();
                      }
                    }}
                  />
                </Fragment>
              )}
              {match.params.gate !== 'site-inspection' && siteData && (
                <FormSectionNew title={localization.stageStatus}>
                  {shouldShowReportAttachment(siteData, match.params.stageId) ? (
                    <Fragment>
                      <div className="form-group">
                        <DocumentView attachment={siteData.report_url} />
                      </div>
                      {match.params.gate !== 'civil-checklist' && (
                        <div className="form-group">
                          <Checkbox
                            label={localization.notify}
                            onChange={(val) => sendMail(val)}
                            type="checkbox"
                          />
                        </div>
                      )}
                    </Fragment>
                  ) : isReportPending ? (
                    <p className="text-muted mb-0">{reportPendingMessage}</p>
                  ) : showGenerateReport ? (
                    <Fragment>
                      {match.params.gate === 'handover-testing' ?
                        <div
                          className="form-group form-generate form-card handover-generate-form"
                          ref={handoverGenerateRef}
                        >
                          {isServiceHandover && (
                            <div className="handover-date-field">
                              <DatePicker
                                label="Handover Date"
                                handleChange={(val) => setHandoverDate(val)}
                                minimumDate={handoverDateBounds.minDate}
                                maxDate={handoverDateBounds.maxDate}
                                required
                              />
                            </div>
                          )}
                          {isServiceHandover && !handoverPreviewConfirmed && (
                            <Button
                              type="button"
                              className="btn btn-primary"
                              onClick={handleHandoverPreview}
                              disabled={isLoading}
                            >
                              Preview
                            </Button>
                          )}
                          {(siteData && siteData.site_data && siteData.site_data.handoverActive === 1) ?
                            (!isServiceHandover || handoverPreviewConfirmed) && (
                              <Button
                                className="btn btn-primary"
                                onClick={() => checklisting()}
                                disabled={isDisabled}
                              >
                                {localization.generateReport + ` Handover`}
                              </Button>
                            )
                            :
                            <span style={{ color: 'red' }}>Please Add 1st Invoice Number</span>
                          }
                        </div>
                        :
                        <div className="form-group form-card">
                          {match.params.stageId == 7 && siteData.fir_filled == 1 ? (
                            <ConstantInput
                              name="subject"
                              label={localization.passcode}
                              type="text"
                              value={passCode}
                              handleChange={(val) => {
                                setPasscode(val);
                              }}
                              isStarRequired={true}
                            />
                          ) : null}
                          <Button
                            className="btn btn-primary"
                            onClick={() => checklisting()}
                            disabled={isDisabled}
                          >
                            {match.params.stageId != 13 ? localization.generateReport : localization.finalBilling}
                          </Button>
                        </div>
                      }
                    </Fragment>
                  ) : null}
                </FormSectionNew>
              )}
              {isServiceHandover && showGenerateReport && handoverPreview && (
                <HandoverInvoicePreview
                  data={handoverPreview}
                  confirmed={handoverPreviewConfirmed}
                  onConfirm={() => {
                    setHandoverPreviewConfirmed(true);
                    handoverGenerateRef.current?.scrollIntoView({
                      behavior: 'smooth',
                      block: 'center',
                    });
                  }}
                />
              )}
            </div>
          </div>



          {/* </div> */}

          <ModalPop
            title={localization.note}
            show={modalFlag}
            handleModalHide={handleModalHide}
            keyboard
            backdrop
          >
            <div className="text-center">
              <h5>{localization.inventoryChecklistNote}</h5>
            </div>
          </ModalPop>

          <ModalPop
            title={localization.note}
            show={isModal}
            handleModalHide={modalHide}
            keyboard
            backdrop
          >
            <div className="text-center">
              <h5>{localization.ChecklistNote}</h5>
            </div>
          </ModalPop>

          <ModalPop
            title={localization.conf}
            show={generateFlag}
            handleModalHide={hideReport}
          >
            <div className="text-center">
              <div className="success">
                <img src={Images?.tick} alt="" />
              </div>
              <h5>{reportSuccessMessage}</h5>

              {(userProfile.attVal && userProfile.attVal[0] && userProfile.attVal[0].lead_id && userProfile.attVal[0].lead_id > 0) ?
                <Link to="/dashboard/check_out" className="btn btn-danger mb-4">Do You Want to Checkout</Link>
                :
                null
              }
            </div>
          </ModalPop>
          <ModalPop
            title={localization.note}
            show={mrfReportModal}
            handleModalHide={mrfReportModalHide}
            keyboard
            backdrop
          >
            <div className="text-center">
              <h5>{localization.mrfMessage}</h5>
            </div>
          </ModalPop>
          <ModalPop
            title={localization.conf}
            show={modal}
            handleModalHide={emailModalHide}
            keyboard
            backdrop
          >
            <div className="text-center">
              <div className="success">
                <img src={Images?.tick} alt="" />
              </div>
              <h5>{localization.mailSuccessfully}</h5>
            </div>
          </ModalPop>
          <ModalPop
            title={localization.notify}
            show={openModal}
            handleModalHide={openHideModal}
            keyboard
            backdrop
          >
            <div className="text-center">
              <DropDownInput
                multipule
                label={localization.toName}
                data={pocListBySiteId}
                required
                isStarRequired={true}
                errorMsg={localization.isRequired}
                getIdValue={(val) => {
                  setPocList(val);
                }}
              />
              {showOtherEmail && (
                <ConstantInput
                  label={localization.emailAddress}
                  regex={Regex.email.test(otherEmail)}
                  errorMsg={localization.emailError}
                  handleChange={(val) => {
                    setOtherEmail(val);
                  }}
                  type="text"
                />
              )}
              <Button
                className="btn btn-primary mb-4"
                onClick={() => {
                  sendMailPoc();
                }}
              >
                {localization.submit} <img src={Images?.ArrowRight} alt="" />
              </Button>
            </div>
          </ModalPop>
          <ModalPop
            title={localization.success}
            show={isSuccessModel}
            handleModalHide={handleRejectModalHide}
          >
            {successIconBox(localization.itemUpdateSuccess, handleRejectModalHide)}
          </ModalPop>
        </>
      }
    </Layout>
  );
};
export default SiteInspection;
